<template>
<div>
    <div class="top-bar">
        <div class="container">
            <FormSelect field="applications.0.department">
              <option :value="null">Select a Department</option>
              <option v-for="option in departments" :key="option.id" :value="option.id">{{ option.label }}</option>
            </FormSelect>
            <ErrorLabel field="applications.0.department" />
            <FormSelect field="applications.0.campaign">
              <option :value="null">Select a Campaign</option>
              <option v-for="option in campaigns" :key="option.id" :value="option.label">{{ option.label }}</option>
            </FormSelect>
            <ErrorLabel field="applications.0.campaign" />
            <FormSelect field="applications.0.subCampaign">
              <option :value="null">Select a Sub Campaign</option>
              <option v-for="option in subCampaigns" :key="option.id" :value="option.label">{{ option.label }}</option>
            </FormSelect>
        </div>
    </div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm formId="adm">
                <FormSection title="Payment Details">
                  <FormRow inline>
                    <FormCol width="half" field="accountID" />
                  </FormRow>
                  <FormRow inline>
                   <FormCol field="firstName" />
                    <FormCol field="lastName" />
                  </FormRow>                
                  <FormRow inline>
                    <FormCol field="email" />
                    <FormCol field="phone" />
                  </FormRow>   
                  <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>               
                </FormSection>
               <FormSection title="Payment Information">
                <FormRow inline>
                  <FormCol field="amount" />
                  <div class="radio-container">                    
                    <FormLabel class="radio-inline">
                        <input type="radio" name="currency" id="currency-usd" :checked="form.currency == 'USD'" @click="setValue('currency', 'USD')"> US Dollars
                    </FormLabel>
                    &nbsp;
                    <FormLabel class="radio-inline">
                        <input type="radio" name="currency" id="currency-cad" :checked="form.currency == 'CAD'" @click="setValue('currency', 'CAD')"> Canadian Dollars
                    </FormLabel>                   
                  </div>
                </FormRow>
                <FormRow inline>
                  <div class="frequency">
                      <PaymentOptions addMonthly />
                    </div>
                </FormRow>
                <FormRow inline>
                  <FormCol field="card"  :showLabel="false"/>
                </FormRow>
               </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormRow>
                    <PaymentButton/>
                </FormRow>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, watch, ref, computed } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form';
import { json } from 'body-parser';

export default defineComponent({
  setup() {
    const { form, setValue, getValue } = usePaymentForm()

    const departments = ref([])

    fetch('https://velocity2.ouapis.org/donation-forms/departments').then(x=>x.json()).then(resp=>departments.value = resp)
    const campaigns = ref<any>([])
    
    //@ts-ignore
    const subCampaigns = computed(() => campaigns.value.find(x=>x.label == getValue('applications.0.campaign'))?.subCampaigns)

    //@ts-ignore
    watch(() => getValue('applications.0.department'), async (department) => {
      campaigns.value = await fetch(
          'https://velocity2.ouapis.org/donation-forms/campaigns/' +
            department
        ).then((x) => x.json())
           
    })
    watch(() => getValue('gateway'), (gateway) => {
      if (gateway == 'SensePassCardknox') {
        setValue('gateway', 'SensePassCardknoxVelocity');
      }

    });


    return {
      form,
      setValue,
      departments,
      campaigns,
      subCampaigns
    }
  }
});
</script>

<style scoped lang="scss">
.top-bar {
  background: #dee4ea;
  padding: 15px 20px 0;
  border-bottom: 1px solid #cfd5dc;

  .container {
    @media only screen and (min-width: 720px) {
      display: flex;
      justify-content: center;
      max-width: 1000px;
      margin: auto;
    }
  }
  select {
    @media only screen and (min-width: 720px) {
      margin: 0 10px 15px;
      max-height: 26px;
      font-size: 14px;
    }
    margin-bottom: 15px;
    background: white;
  }
}

.radio-container {
  padding-top: 20px;
  @media only screen and (min-width: 720px) {
    padding-top: 40px;
  }
}
</style>
